import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import SingleItem from "./SingleItem";
import { toast } from "react-toastify";
import axios from "axios";
import { RotatingSquare } from "react-loader-spinner";
import CustomPagination from "../../../../CustomPagination/CustomPagination";
import { Modal } from "react-bootstrap";
import AddNormalOrderModal from "./Add/AddNormalOrderModal";
import AddComboOrderModal from "./Add/AddComboOrderModal";
import EditNormalOrderModal from "./Edit/EditNormalOrderModal";
import EditComboOrderModal from "./Edit/EditComboOrderModal";
import { useParams } from "react-router-dom";

const OrderList = ({ PlatformData }) => {

    const { id } = useParams();

    // view data
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [results, setResults] = useState({});


    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/order/order-set/view/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data.data);
                setLoading(false);
            });
    }, [results]);


    const handleEnableDisabled = (id) => {
        fetch(
            `https://api.velormall.com/api/admin/order/enable-disable/${id}`,
            {
                method: "PATCH",
                headers: {
                    "content-type": "application/json",
                },
            }
        )
            .then((res) => res.json())
            .then((data) => {
                setResults(data);
                if (data?.data?.status) {
                    toast.success(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                } else {
                    toast.error(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                }
            })
            .catch((error) => console.log(error));
    };

    const handleDelete = (id) => {
        fetch(`https://api.velormall.com/api/admin/order/delete/${id}`, {
            method: "DELETE",
            headers: {
                "content-type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                setResults(data);
                toast.error(`${data.message}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            })
            .catch((error) => console.log(error));
    };

    // normal order modal add
    const [showNormalOrderAdd, setShowNormalOrderAdd] = useState(false);
    const handleCloseNormalOrderAdd = () => setShowNormalOrderAdd(false);
    const handleShowNormalOrderAdd = () => setShowNormalOrderAdd(true);


    // combo order modal add 
    const [showAddComboOrderAdd, setShowAddComboOrderAdd] = useState(false);
    const handleCloseAddComboOrderAdd = () => setShowAddComboOrderAdd(false);
    const handleShowAddComboOrderAdd = () => setShowAddComboOrderAdd(true);


    // normal order modal edit
    const [showNormalOrderEdit, setShowNormalOrderEdit] = useState(false);
    const handleCloseNormalOrderEdit = () => setShowNormalOrderEdit(false);
    const handleShowNormalOrderEdit = () => setShowNormalOrderEdit(true);



    // combo order modal edit
    const [showAddComboOrderEdit, setShowAddComboOrderEdit] = useState(false);
    const handleCloseAddComboOrderEdit = () => setShowAddComboOrderEdit(false);
    const handleShowAddComboOrderEdit = () => setShowAddComboOrderEdit(true);


    const [editData, setEditData] = useState({});


    const HandleOrderEditModalShow = ({ data, type }) => {
        if (data?.type === "Normal") {
            handleShowNormalOrderEdit();
        }

        if (data?.type === "Combo") {
            handleShowAddComboOrderEdit();
        }
        setEditData(data)
    }

    if (loading) {
        return (
            <>
                <div className="loader-css">
                    <RotatingSquare
                        visible={true}
                        height="100"
                        width="100"
                        color="#4fa94d"
                        ariaLabel="rotating-square-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                </div>
            </>
        );
    }

    return (
        <>

            <div className="card">
                <div className="card-body">
                    <div className="d-flex mb-2 flex-wrap gap-3 justify-content-between align-items-center">
                        <h6 className="page-title">Order Lists</h6>
                        <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                            <button
                                onClick={handleShowAddComboOrderAdd}
                                className="btn btn-sm btn-outline-primary addBtn"
                            >
                                <i className="las la-plus"></i>
                                Add Combo Order
                            </button>
                            <button
                                onClick={handleShowNormalOrderAdd}
                                className="btn btn-sm btn-outline-primary addBtn"
                            >
                                <i className="las la-plus"></i>
                                Add  Order
                            </button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card b-radius--10 ">
                                <div className="card-body p-0">
                                    <div className="table-responsive--md  table-responsive">
                                        <table className="table table--light style-two mb-0">
                                            <thead>
                                                <tr>
                                                    <th>S.N</th>
                                                    <th>Type</th>
                                                    <th>Order #</th>
                                                    <th>Platform</th>
                                                    <th>Manage Crypto</th>
                                                    <th>Order Amount</th>
                                                    <th>Profit %</th>
                                                    <th>Profit Amount</th>
                                                    <th>Total With Profit</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.length !== 0 ? (
                                                    data.map((data, index) => {
                                                        if (data) {
                                                            return (
                                                                <SingleItem
                                                                    data={data}
                                                                    index={index}
                                                                    key={data._id}
                                                                    handleDelete={handleDelete}
                                                                    handleEnableDisabled={handleEnableDisabled}
                                                                    HandleOrderEditModalShow={HandleOrderEditModalShow}
                                                                ></SingleItem>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td className="text-muted text-center" colspan="100%">
                                                            Data not found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* AddNormalOrderModal  */}
            <Modal show={showNormalOrderAdd} onHide={handleCloseNormalOrderAdd} backdrop="static" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title> Order </Modal.Title>
                </Modal.Header>
                <AddNormalOrderModal PlatformSingleData={PlatformData} handleCloseNormalOrderAdd={handleCloseNormalOrderAdd} setResults={setResults} />
            </Modal>

            {/* AddComboOrderModal  */}
            <Modal show={showAddComboOrderAdd} onHide={handleCloseAddComboOrderAdd} backdrop="static" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Combo Order</Modal.Title>
                </Modal.Header>
                <AddComboOrderModal PlatformSingleData={PlatformData} handleCloseAddComboOrderAdd={handleCloseAddComboOrderAdd} setResults={setResults} />
            </Modal>

            {/* EditNormalOrderModal  */}
            <Modal show={showNormalOrderEdit} onHide={handleCloseNormalOrderEdit} backdrop="static" size="lg" >
                <Modal.Header closeButton>
                    <Modal.Title> Order Update</Modal.Title>
                </Modal.Header>
                <EditNormalOrderModal OrderSingleData={editData} setResults={setResults} handleCloseNormalOrderEdit={handleCloseNormalOrderEdit} />
            </Modal>

            {/* EditComboOrderModal  */}
            <Modal show={showAddComboOrderEdit} onHide={handleCloseAddComboOrderEdit} backdrop="static" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Combo Order Update</Modal.Title>
                </Modal.Header>
                <EditComboOrderModal editData={editData} setResults={setResults} handleCloseAddComboOrderEdit={handleCloseAddComboOrderEdit} />
            </Modal>

        </>
    );

};

export default OrderList;
